let _initProto, _initClass, _init_value, _init_extra_value, _init_variant, _init_extra_variant, _init_size, _init_extra_size, _init_label, _init_extra_label, _init_disabled, _init_extra_disabled, _init_changeEvent, _init_extra_changeEvent;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { RadiantElement, customElement, event, onEvent, onUpdated, prop } from "@ecopages/radiant";
import { cycleValue } from "@/lib/cycle-value";
const ITEM_SELECTOR = "[data-cycle-value]";
const BUTTON_SELECTOR = "button[data-cycle-toggle-button]";
let _RuiCycleToggle;
class RuiCycleToggle extends RadiantElement {
  static {
    ({
      e: [_init_value, _init_extra_value, _init_variant, _init_extra_variant, _init_size, _init_extra_size, _init_label, _init_extra_label, _init_disabled, _init_extra_disabled, _init_changeEvent, _init_extra_changeEvent, _initProto],
      c: [_RuiCycleToggle, _initClass]
    } = _applyDecs(this, [customElement("rui-cycle-toggle")], [[prop({
      type: String,
      reflect: true,
      defaultValue: ""
    }), 0, "value"], [prop({
      type: String,
      reflect: true,
      defaultValue: "filled"
    }), 0, "variant"], [prop({
      type: String,
      reflect: true,
      defaultValue: "md"
    }), 0, "size"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "label"], [prop({
      type: Boolean,
      reflect: true,
      defaultValue: false
    }), 0, "disabled"], [event({
      name: "rui-change",
      bubbles: true,
      composed: true
    }), 0, "changeEvent"], [onUpdated(["value", "label", "disabled", "size", "variant"]), 2, "onPropsUpdated"], [onEvent({
      selector: BUTTON_SELECTOR,
      type: "click"
    }), 2, "onButtonClick"]], 0, void 0, RadiantElement));
  }
  value = (_initProto(this), _init_value(this));
  variant = (_init_extra_value(this), _init_variant(this));
  size = (_init_extra_variant(this), _init_size(this));
  label = (_init_extra_size(this), _init_label(this));
  disabled = (_init_extra_label(this), _init_disabled(this));
  changeEvent = (_init_extra_disabled(this), _init_changeEvent(this));
  childObserver = (_init_extra_changeEvent(this), null);
  connectedCallback() {
    super.connectedCallback();
    this.childObserver = new MutationObserver(() => this.resync());
    this.childObserver.observe(this, {
      childList: true,
      subtree: true
    });
  }
  onConnected() {
    this.resync();
  }
  disconnectedCallback() {
    this.childObserver?.disconnect();
    this.childObserver = null;
    super.disconnectedCallback();
  }
  onPropsUpdated() {
    this.resync();
  }
  /** Re-applies button labeling and the visible cycle item from the current `value`. */
  resync() {
    const selected = this.syncSelection(this.value || this.getItemValue(this.getEnabledItems()[0]) || "");
    this.syncButtonPresentation();
    this.syncButtonLabel(selected);
  }
  getItems() {
    return Array.from(this.querySelectorAll(ITEM_SELECTOR));
  }
  getEnabledItems() {
    return this.getItems().filter(item => item.getAttribute("aria-disabled") !== "true");
  }
  getItemValue(item) {
    if (!item) return "";
    return item.dataset.cycleValue ?? "";
  }
  syncButtonLabel(selected) {
    const button = this.querySelector(BUTTON_SELECTOR);
    if (!button) return;
    const selectedLabel = selected?.querySelector("[aria-label]")?.ariaLabel ?? selected?.textContent?.trim();
    if (!this.label || !selectedLabel) {
      button.removeAttribute("aria-label");
      return;
    }
    button.setAttribute("aria-label", `${this.label}: ${selectedLabel}`);
  }
  syncButtonPresentation() {
    const button = this.querySelector(BUTTON_SELECTOR);
    if (!button) return;
    button.disabled = this.disabled;
    for (const className of Array.from(button.classList)) {
      if (className.startsWith("rui-button--")) button.classList.remove(className);
    }
    button.classList.add(`rui-button--${this.variant}`, `rui-button--${this.size}`);
  }
  syncSelection(nextValue) {
    const items = this.getItems();
    if (!items.length) return void 0;
    const enabled = this.getEnabledItems();
    const selected = items.find(item => this.getItemValue(item) === nextValue && enabled.includes(item)) ?? enabled[0] ?? items[0];
    const selectedValue = this.getItemValue(selected);
    this.value = selectedValue;
    for (const item of items) {
      item.hidden = item !== selected;
    }
    return selected;
  }
  cycle() {
    if (this.disabled) return;
    const enabled = this.getEnabledItems();
    const values = enabled.map(item => this.getItemValue(item)).filter(Boolean);
    if (!values.length) return;
    const next = cycleValue(values, this.value || void 0);
    if (next === this.value) return;
    this.syncSelection(next);
    this.changeEvent.emit({
      value: this.value
    });
  }
  onButtonClick() {
    this.cycle();
  }
  static {
    _initClass();
  }
}
export { _RuiCycleToggle as RuiCycleToggle };